export function randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const shortenAddress = (address, prefixLength = 6, suffixLength = 4) => {
    if (!address || address.length < prefixLength + suffixLength) return address;
    return `${address.slice(0, prefixLength)}...${address.slice(-suffixLength)}`;
};

export function getDeviceInfo() {
    const userAgent = navigator.userAgent;

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTablet = /iPad|Android|Tablet/i.test(userAgent);
    const isDesktop = !isMobile && !isTablet;

    let os = 'Unknown';
    if (/Windows/i.test(userAgent)) {
        os = 'Windows';
    } else if (/Macintosh|Mac OS X/i.test(userAgent)) {
        os = 'Mac';
    } else if (/Android/i.test(userAgent)) {
        os = 'Android';
    } else if (/iOS|iPhone|iPad|iPod/i.test(userAgent)) {
        os = 'iOS';
    } else if (/Linux/i.test(userAgent)) {
        os = 'Linux';
    }

    let browser = 'Unknown';
    if (/Chrome/i.test(userAgent)) {
        browser = 'Chrome';
    } else if (/Firefox/i.test(userAgent)) {
        browser = 'Firefox';
    } else if (/Safari/i.test(userAgent)) {
        browser = 'Safari';
    } else if (/Edge/i.test(userAgent)) {
        browser = 'Edge';
    } else if (/Opera|OPR/i.test(userAgent)) {
        browser = 'Opera';
    } else if (/Trident/i.test(userAgent)) {
        browser = 'Internet Explorer';
    }

    // Trả về thông tin thiết bị
    return {
        deviceType: isMobile ? 'Mobile' : isTablet ? 'Tablet' : 'Desktop',
        operatingSystem: os,
        browser: browser,
        userAgent: userAgent, // Trả về toàn bộ chuỗi User-Agent nếu cần
    };
}